import type { ReactNode } from "react";

import DemoBanner from "@/modules/demo/ui/demo-banner";

// 데모 화면 전부 — 맨 위에 「데모 화면입니다」 띠를 단다(로그인·토큰 없이 열린다) · 상태바 높이는 띠 위에서 한 번만 비운다(첫 화면은 safeTop 을 끈다).
const DemoLayout = ({ children }: { children: ReactNode }) => (
  <>
    <div className="print-hide pt-safe">
      <DemoBanner />
    </div>
    {children}
  </>
);

export default DemoLayout;
